export const textEn =
  {
    tit: "Cookie Settings and Privacy",
    sub: "We use cookies and collect data to ensure the best experience on our website. This process is subject to the following ",
    anc: "Privacy Policies",
    txt: "By clicking 'Accept', you consent to the use of cookies and data processing for personalized and non-personalized advertising purposes.",
    but: "Accept"
  };



export const textEs =
  {
    tit:"Configuración de cookies y privacidad",
    sub:"Utilizamos cookies y recopilamos datos para garantizar la mejor experiencia en nuestro sitio web. Este proceso está sujeto a las siguientes ",
    anc: "Políticas de privacidad",
    txt: "Al hacer clic en 'Aceptar', estás consintiendo el uso de cookies y el procesamiento de datos para fines de publicidad personalizada y no personalizada.",
    but:"Aceptar"
  };
